<template>
    <select v-model="paginator" @change="change()">
        <option
            v-for="(url, page) in range"
            :value="url"
            :selected="selected(page)"
        >{{ page }}</option>
    </select>
</template>
<script>
    export default {
        props: {
            range: {
                type: Object,
                required: false,
                default: {}
            },
            current: {
                type: Number,
                required: true
            },
            currentUrl: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                paginator: this.currentUrl
            };
        },
        methods: {
            selected(page) {
                return page === this.current;
            },
            change() {
                window.location.href = this.paginator;
                EventBus.fire('pagination-change', this.paginator);
            }
        }
    };
</script>